import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { RankListItemMessage, RankListResponseWrapper } from "src/app/api/models";

export const roomchampionsEntityKey = 'roomchampions';

export interface RoomchampionsEntity extends RankListResponseWrapper { }

export interface RoomchampionsState extends EntityState<RoomchampionsEntity> { }

export const adapter: EntityAdapter<RoomchampionsEntity> = createEntityAdapter<RoomchampionsEntity>();

const initialRoomchampionsState: RoomchampionsState = adapter.getInitialState(
    {} as RoomchampionsState,
);

export function getInitialRoomchampionsState(): RoomchampionsState {
    return initialRoomchampionsState;
}